var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPharmacy = function SvgPharmacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAF3",
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#113628",
    strokeWidth: 2,
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#061F15",
    d: "M21.437 15h-2.873v3.564H15v2.872h3.564V25h2.873v-3.564H25v-2.872h-3.563z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#061F15",
    d: "M11.25 13.75v-2.5h17.5v17.5h-17.5v-15Z"
  })));
};
export default SvgPharmacy;